import { Button, Flex } from "antd";
import { FilterIcon } from "../../assets";
import { Popup } from "../../components";
import FilterForm from "../../forms/FilterForm";
import { usePopup } from "../../hooks/usePopup";
import AppliedFilter from "../../forms/AppliedFilter";
import { useAppSelector } from "../../redux/hooks";
import { getFinanceState } from "../../redux/store/getState";
import FinanceAtcTable from "./FinanceAtcTable";

export default function FinanceAtc() {
  const popup = usePopup();
  const { total_requested_vouchers, total_used_vouchers } =
    useAppSelector(getFinanceState);

  return (
    <>
      <Flex gap="large" wrap="wrap">
        <Popup
          ref={popup.popupRef}
          openTrigger={
            <Button icon={<FilterIcon style={{ marginTop: 2 }} />}>
              Filter
            </Button>
          }
        >
          <FilterForm popup={popup} />
        </Popup>
        <AppliedFilter />
        <Button type="primary" style={{ backgroundColor: "#533031" }}>
          Total Requested Voucher: {total_requested_vouchers}
        </Button>
        <Button type="primary" style={{ backgroundColor: "#533031" }}>
          Total Used Vouchers: {total_used_vouchers}
        </Button>
      </Flex>
      <FinanceAtcTable />
    </>
  );
}
